<template>
 <sdDrawer
  ref="shopSubProductAddRef"
  :form="form"
  :showOpenButton="false"
  btnText="Toevoegen"
  submitBtnText="Opslaan"
  title="Product configuratie"
  type="submit"
 >
  <FormValidationWrap>
   <a-form ref="formRef" :model="form" layout="vertical" @finish="updateShopSubProduct">
    <a-row :gutter="16">
     <a-col :xs="24">
      <Upload>
       <figure class="photo-upload align-center-v">
        <img
         v-if="form.imageFileURL && form.imageFileURL !== ''"
         :src="form.imageFileURL"
         alt=""
         style="max-width: 120px"
        />
        <img
         v-else
         :src="require('@/static/img/avatar/profileImage.png')"
         alt=""
         style="max-width: 120px"
        />
        <figcaption>
         <a-upload
          :action="`${fileUrl}products/${params.id}/subproducts/${form.id}/file`"
          :disabled="!$can('update', 'user')"
          :headers="fileUploadHeaders"
          :multiple="false"
          name="file"
          @change="handleUpload">
          <a class="btn-upload" to="#">
           <sdFeatherIcons size="16" type="camera"/>
          </a>
         </a-upload>
        </figcaption>
       </figure>
      </Upload>
     </a-col>
     <a-col :sm="12" :xs="24">
      <a-form-item :rules="{required: true,message: 'Dit veld is verplicht'}" label="Naam" name="name">
       <a-input v-model:value="form.name" placeholder=""/>
      </a-form-item>
     </a-col>
     <a-col :sm="12" :xs="24">
      <a-form-item label="Artikelnummer" name="externalReference">
       <a-input v-model:value="form.externalReference" placeholder="" type="text"/>
      </a-form-item>
     </a-col>
     <a-col :sm="12" :xs="24">
      <a-form-item :rules="[{required: true,message: 'Dit veld is verplicht'},{validator: amountValidator}]"
                   label="Bedrag" name="amount">
       <a-input v-model:value="form.amount" placeholder="" type="text"/>
      </a-form-item>
     </a-col>
     <a-col :sm="12" :xs="24">
      <a-form-item :rules="{required: true,message: 'Dit veld is verplicht'}" label="Actief"
                   name="active">
       <a-select v-model:value="form.active" :allowClear="true"
                 :disabled="!$can('update', 'product')" class="sDash_fullwidth-select"
                 size="large">
        <a-select-option v-for="(item,index) in defaultOptions" :key="index"
                         :value="item.value" name="active">
         {{ item.key }}
        </a-select-option>
       </a-select>
      </a-form-item>
     </a-col>
     <a-col :sm="12" :xs="24">
      <a-form-item :rules="{required: true,message: 'Dit veld is verplicht'}" label="Auto synchronisatie"
                   name="hasAutoSync">
       <a-select v-model:value="form.hasAutoSync" :allowClear="true"
                 :disabled="!$can('update', 'product')" class="sDash_fullwidth-select"
                 size="large">
        <a-select-option v-for="(item,index) in defaultOptions" :key="index"
                         :value="item.value" name="hasAutoSync">
         {{ item.key }}
        </a-select-option>
       </a-select>
      </a-form-item>
     </a-col>
     <a-col :sm="12" :xs="24">
      <a-form-item :rules="{required: true,message: 'Dit veld is verplicht'}" label="Categorie"
                   name="subCategoryID">
       <a-select v-model:value="form.subCategoryID" :allowClear="true"
                 :disabled="!$can('update', 'product')" class="sDash_fullwidth-select"
                 size="large">
        <a-select-option v-for="(item,index) in productSubCategories" :key="index"
                         :value="item.id" name="subCategoryID">
         {{ item.name }}
        </a-select-option>
       </a-select>
      </a-form-item>
     </a-col>
     <a-col v-if="isSustainabilityAdvanced" :sm="12" :xs="24">
      <a-form-item label="Parent product (optioneel)" name="parentID">
       <a-select v-model:value="form.parentID" :allowClear="true"
                 :disabled="!$can('update', 'product')" class="sDash_fullwidth-select"
                 size="large" placeholder="Geen (top-level product)">
        <a-select-option :value="null">Geen (top-level product)</a-select-option>
        <a-select-option v-for="item in parentProducts" :key="item.id" :value="item.id">
         {{ item.name }}
        </a-select-option>
       </a-select>
      </a-form-item>
     </a-col>
     <a-col v-if="isSustainabilityAdvanced" :sm="12" :xs="24">
      <a-form-item label="Is subsidieregel?" name="isSubsidy">
       <a-select v-model:value="form.isSubsidy"
                 :disabled="!$can('update', 'product')" class="sDash_fullwidth-select"
                 size="large">
        <a-select-option :value="false">Nee</a-select-option>
        <a-select-option :value="true">Ja</a-select-option>
       </a-select>
      </a-form-item>
     </a-col>
     <template v-if="isSustainabilityAdvanced && form.isSubsidy">
      <a-col :xs="24"><h4 class="mt-2">Subsidieberekening</h4></a-col>
      <a-col :sm="12" :xs="24">
       <a-form-item label="Bedrag berekenen als" name="subsidyCode">
        <a-select v-model:value="form.subsidyCode" class="sDash_fullwidth-select" size="large">
         <a-select-option v-for="item in subsidyCodeOptions" :key="String(item.value)" :value="item.value">
          {{ item.key }}
         </a-select-option>
        </a-select>
       </a-form-item>
      </a-col>
     </template>

     <template v-if="isSustainabilityAdvanced && !form.isSubsidy && !form.parentID">
      <a-col :xs="24"><h4 class="mt-2">Pakket</h4></a-col>
      <a-col :sm="12" :xs="24">
       <a-form-item label="Prijsmethode" name="priceMethod">
        <a-select v-model:value="form.priceMethod" class="sDash_fullwidth-select" size="large">
         <a-select-option v-for="item in priceMethodOptions" :key="String(item.value)" :value="item.value">
          {{ item.key }}
         </a-select-option>
        </a-select>
       </a-form-item>
      </a-col>
      <a-col :sm="12" :xs="24">
       <a-form-item label="Maximale interne inkoop (excl. btw)" name="maxPurchasePrice">
        <a-input v-model:value="form.maxPurchasePrice" placeholder="Geen maximum" type="number"/>
       </a-form-item>
      </a-col>
      <a-col :sm="12" :xs="24">
       <a-form-item label="Maximaal aantal isolatiemaatregelen" name="maxIsolationMeasures">
        <a-input v-model:value="form.maxIsolationMeasures" placeholder="Geen maximum" type="number"/>
       </a-form-item>
      </a-col>
      <a-col :sm="12" :xs="24">
       <a-form-item label="Geen loyaliteitskorting" name="excludesLoyaltyDiscount">
        <a-select v-model:value="form.excludesLoyaltyDiscount" class="sDash_fullwidth-select" size="large">
         <a-select-option :value="false">Nee</a-select-option>
         <a-select-option :value="true">Ja, order met dit pakket krijgt geen loyaliteitskorting</a-select-option>
        </a-select>
       </a-form-item>
      </a-col>
      <a-col :sm="12" :xs="24">
       <a-form-item label="Geldig van / tot" name="validFrom">
        <a-row :gutter="8">
         <a-col :span="12">
          <a-date-picker v-model:value="form.validFrom" format="DD-MM-YYYY" placeholder="Vanaf" style="width: 100%"
                         value-format="YYYY-MM-DD"/>
         </a-col>
         <a-col :span="12">
          <a-date-picker v-model:value="form.validTill" format="DD-MM-YYYY" placeholder="Tot en met" style="width: 100%"
                         value-format="YYYY-MM-DD"/>
         </a-col>
        </a-row>
       </a-form-item>
      </a-col>
     </template>

     <template v-if="isSustainabilityAdvanced && !form.isSubsidy">
      <a-col :xs="24"><h4 class="mt-2">Inkoop en techniek <small>(intern, niet zichtbaar voor verkoop)</small></h4></a-col>
      <a-col :sm="12" :xs="24">
       <a-form-item label="Inkoopprijs (excl. btw)" name="purchasePrice">
        <a-input v-model:value="form.purchasePrice" placeholder="Onbekend" type="number"/>
       </a-form-item>
      </a-col>
      <a-col :sm="12" :xs="24">
       <a-form-item label="Inkoop per" name="purchaseUnit">
        <a-select v-model:value="form.purchaseUnit" class="sDash_fullwidth-select" size="large">
         <a-select-option v-for="item in purchaseUnitOptions" :key="String(item.value)" :value="item.value">
          {{ item.key }}
         </a-select-option>
        </a-select>
       </a-form-item>
      </a-col>
      <a-col :sm="12" :xs="24">
       <a-form-item label="Isolatiemaatregel" name="isolationMeasure">
        <a-select v-model:value="form.isolationMeasure" class="sDash_fullwidth-select" size="large">
         <a-select-option v-for="item in isolationMeasureOptions" :key="String(item.value)" :value="item.value">
          {{ item.key }}
         </a-select-option>
        </a-select>
       </a-form-item>
      </a-col>
      <a-col :sm="12" :xs="24">
       <a-form-item label="Vermogen volgens RVO-meldcode (kW)" name="powerKw">
        <a-input v-model:value="form.powerKw" placeholder="Alleen warmtepomp" type="number"/>
       </a-form-item>
      </a-col>
      <a-col :sm="12" :xs="24">
       <a-form-item label="RVO-meldcode" name="meldcode">
        <a-input v-model:value="form.meldcode" placeholder="Alleen warmtepomp"/>
       </a-form-item>
      </a-col>
      <a-col :sm="12" :xs="24">
       <a-form-item label="Energielabel A+++" name="hasTopEnergyLabel">
        <a-select v-model:value="form.hasTopEnergyLabel" class="sDash_fullwidth-select" size="large">
         <a-select-option :value="false">Nee</a-select-option>
         <a-select-option :value="true">Ja</a-select-option>
        </a-select>
       </a-form-item>
      </a-col>
     </template>
     <a-col :xs="24">
      <a-form-item label="Omschrijving">
       <div class="sDash_editor">
 <textarea
  v-model="form.description"
  :disabled="!$can('update', 'product')"
  class="form-control w-100"
  placeholder="Voer hier de productbeschrijving in"
  rows="6"
 ></textarea>

       </div>
      </a-form-item>
     </a-col>
    </a-row>
    <div
     :style="{
            position: 'absolute',
            right: 0,
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e9e9e9',
            padding: '10px 16px',
            background: '#fff',
            textAlign: 'right',
            zIndex: 1,
          }"
    >
     <a-button :loading="loadingPatchShopSubProduct" :disabled="loadingPatchShopSubProduct" class="btn-signin" html-type="submit" type="primary"> Opslaan
     </a-button>
    </div>
   </a-form>
  </FormValidationWrap>
 </sdDrawer>
</template>
<script>
import {computed, defineComponent, ref} from 'vue';
import {useStore} from "vuex";
import {FormValidationWrap, Upload} from "@/view/styled";
import {useRoute} from "vue-router";
import {getItem} from "@/utility/localStorageControl";
import {DataService, getApiURL} from "@/config/dataService/dataService";
import {defaultOptions,} from "../../../utility/enums";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {amountValidator} from "@/utility/validators";

const subsidyCodeOptions = [
 {key: 'Vast bedrag (uit dit product)', value: null},
 {key: 'ISDE warmtepomp (vermogen en A+++ van de warmtepomp in dit pakket)', value: 'ISDE_HEATPUMP'},
 {key: 'ISDE isolatie (m² per maatregel)', value: 'ISDE_ISOLATION'},
 {key: 'Gemeente: isolatie', value: 'MUNICIPAL_ISOLATION'},
 {key: 'Gemeente: warmtepomp', value: 'MUNICIPAL_HEATPUMP'},
 {key: 'Gemeente: batterij', value: 'MUNICIPAL_BATTERY'},
];
const priceMethodOptions = [
 {key: 'Vaste pakketprijs (Bedrag hierboven)', value: null},
 {key: 'Som van de onderdelen', value: 'SUM'},
];
const purchaseUnitOptions = [
 {key: 'Stuk', value: null},
 {key: 'm² (isolatie)', value: 'M2'},
];
const isolationMeasureOptions = [
 {key: 'Geen', value: null},
 {key: 'Spouwmuur', value: 'SPOUW'},
 {key: 'Vloer', value: 'VLOER'},
 {key: 'Bodem', value: 'BODEM'},
 {key: 'Dak', value: 'DAK'},
];

const EditShopSubProduct = defineComponent({
 name: 'EditShopSubProduct',
 components: {
  FormValidationWrap,
  Upload,
 },
 data() {
  return {
   loading: false,
   fileUrl: getApiURL(),
   editor: ClassicEditor,
   editorConfig: {
    height: 200,
    autoParagraph: false,
   },
  }
 },
 setup() {
  const shopSubProductAddRef = ref();
  const formRef = ref();
  const {params} = useRoute();
  const {state, dispatch} = useStore();
  const productsSubProducts = computed(() => state.shop.productsSubProducts);
  const loadingPatchShopSubProduct = computed(() => state.shop.loadingPatchShopSubProduct);
  const form = computed(() => state.shop.subProduct);
  const productSubCategories = computed(() => state.shop.productSubCategories);
  const isSustainabilityAdvanced = computed(() => state.product.product?.subType === 'SUSTAINABILITYADVANCED');
  const parentProductsList = ref([]);
  const parentProducts = computed(() => {
   return parentProductsList.value.filter(p => p.id !== form.value?.id);
  });

  const closeDrawer = () => {
   shopSubProductAddRef.value.handleCancel();
   formRef.value.resetFields();
   dispatch('resetShopSubProduct');
   dispatch('fetchShopSubProducts', {id: params.id, page: productsSubProducts.value.currentPage})
  }

  const showDrawer = async (id) => {
   await dispatch('getShopSubProduct', {shopId: params.id, id: id});
   try {
    const response = await DataService.getAllCollection(`products/${params.id}/subproducts`);
    parentProductsList.value = (response.data || []).filter(p => !p.parentID);
   } catch (err) {
    parentProductsList.value = [];
   }
   await shopSubProductAddRef.value.showDrawer();
  }
  const updateShopSubProduct = () => {
   form.value.shopId = params.id;
   dispatch('patchShopSubProduct', {value: form.value, close: closeDrawer});
  };

  const fileUploadHeaders = {
   Authorization: `Bearer ${getItem('access_token')}`
  };

  const handleUpload = async (info) => {
   if (info.file.status === 'done') {
    await dispatch('getShopSubProduct', {shopId: params.id, id: form.value.id});
    await dispatch('fileUploadedSuccess');
   } else if (info.file.status === 'error') {
    await dispatch('fileUploadedError');
   }
  };

  return {
   form,
   updateShopSubProduct,
   shopSubProductAddRef,
   formRef,
   showDrawer,
   fileUploadHeaders,
   handleUpload,
   defaultOptions,
   loadingPatchShopSubProduct,
   amountValidator,
   productSubCategories,
   parentProducts,
   isSustainabilityAdvanced,
   params,
   subsidyCodeOptions,
   priceMethodOptions,
   purchaseUnitOptions,
   isolationMeasureOptions,
  };
 },
});

export default EditShopSubProduct;
</script>
